<div class="content-card content-card-accordion card flex-1">
    <ng-content></ng-content>
</div>
